import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { formatApiErrorDetail } from "../lib/api";
import KibliLogo from "../components/KibliLogo";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email.trim(), password);
      navigate("/home");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-white flex flex-col items-center justify-center px-6 py-10">
      <div className="w-full max-w-md flex flex-col items-center gap-6 animate-fade-in-up">
        <KibliLogo size={64} />
        <div className="text-center">
          <h1 className="text-2xl md:text-3xl font-extrabold">Bienvenido de nuevo</h1>
          <p className="text-slate-500 mt-1">Inicia sesión para continuar</p>
        </div>

        <form onSubmit={onSubmit} className="w-full space-y-4">
          <div>
            <label className="block text-sm font-semibold text-slate-700 mb-1">Email</label>
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="tu@email.com"
              data-testid="login-email-input"
              className="input-base"
            />
          </div>
          <div>
            <label className="block text-sm font-semibold text-slate-700 mb-1">Contraseña</label>
            <div className="relative">
              <input
                type={showPassword ? "text" : "password"}
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="••••••••"
                data-testid="login-password-input"
                className="input-base pr-12"
                autoComplete="current-password"
                spellCheck={false}
              />
              <button
                type="button"
                onClick={() => setShowPassword((v) => !v)}
                data-testid="toggle-password-visibility"
                className="absolute inset-y-0 right-3 my-auto h-9 w-9 flex items-center justify-center text-slate-500 hover:text-slate-700"
                aria-label={showPassword ? "Ocultar contraseña" : "Mostrar contraseña"}
              >
                <i className={`fa-solid ${showPassword ? "fa-eye-slash" : "fa-eye"}`}></i>
              </button>
            </div>
          </div>
          {error && <div className="text-sm text-red-600 bg-red-50 border border-red-200 rounded-xl p-3" data-testid="login-error">{error}</div>}
          <button
            type="submit"
            disabled={loading}
            data-testid="login-submit-btn"
            className="btn-primary w-full py-4"
          >
            {loading ? "Entrando..." : "Iniciar sesión"}
          </button>
          <div className="text-center -mt-1">
            <Link to="/forgot-password" className="text-sm text-blue-600 hover:underline font-semibold" data-testid="goto-forgot-link">
              ¿Has olvidado tu contraseña?
            </Link>
          </div>
        </form>

        <Link to="/register" className="text-blue-600 font-semibold" data-testid="goto-register-link">
          ¿No tienes cuenta? Crear cuenta
        </Link>

        <div className="text-xs text-slate-400 text-center mt-2 leading-relaxed">
          Familia demo: <span className="font-semibold">gema@kibliapp.com / kibli123</span>
          <br />Admins: <span className="font-semibold">admin@kibliapp.com / admin123</span>
          <br />o <span className="font-semibold">mollysound@gmail.com / .Admingemita.</span>
        </div>
      </div>
    </div>
  );
}
